<!---router-outlet></router-outlet-->
<sn-scaffolding>
  <ng-template snScaffoldingSubnav>
    <sn-subnav>
      <ng-container *ngFor="let link of navigationLinks">
        <sn-subnav-link *ngIf="hasAppAccess" routerLink="{{link.link}}" routerLinkActive="active">
            <i class="fas {{link.icon}}"></i><span>{{link.text}}&nbsp;</span>
        </sn-subnav-link>
      </ng-container>
    </sn-subnav>
  </ng-template>
  <ng-template snScaffoldingContent>
    <div class="ecova-page">
        <div class="subtitle">{{NavService.Subtitle}}</div>
        <router-outlet></router-outlet>
    </div>
  </ng-template>
</sn-scaffolding>
